export * from './lottery-diamond.component';